import Environment from "../types/environment";

export const getLocalEnvironment = () => {
  const host = document.location.host.toLowerCase();
  const envSubdomain = host.split(".")[0];
  if (envSubdomain === "dev") {
    return Environment.dev;
  }
  if (envSubdomain === "acceptance") {
    return Environment.acceptance;
  }
  return Environment.prod;
};
